document.addEventListener("DOMContentLoaded", () => {
  $('.footer-block-title').click(function () {
    $(this).siblings(".footer-block__details-content").slideToggle();
    var icon = $(this).find('.icon-caret')

    if(icon.hasClass('svg_rotate')) {
      icon.removeClass('svg_rotate')
    } else {
      icon.addClass('svg_rotate')
    }
  });
});
